import { render } from "./HeaderItem.vue?vue&type=template&id=647e47e0"
import script from "./HeaderItem.vue?vue&type=script&lang=js"
export * from "./HeaderItem.vue?vue&type=script&lang=js"

import "./HeaderItem.vue?vue&type=style&index=0&id=647e47e0&lang=scss"

import exportComponent from "D:\\angren\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__